import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "bcu_cookie_consent_v1";
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";

// Meta Pixel is loaded globally in public/index.html so PageView tracking works
// on every route from the very first request. This helper only wires up GA4,
// which stays behind cookie consent.
function loadAnalytics() {
  if (typeof window === "undefined") return;
  if (GA4_ID && !window.__bcuGA4Loaded) {
    window.__bcuGA4Loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4_ID, { anonymize_ip: true });
  }
}

export default function CookieConsent() {
  const [choice, setChoice] = useState(null); // null | "accepted" | "declined"

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "accepted") { setChoice("accepted"); loadAnalytics(); return; }
      if (stored === "declined") { setChoice("declined"); return; }
    } catch { /* ignore */ }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
    setChoice(value);
    if (value === "accepted") loadAnalytics();
  };

  if (choice) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] bg-[#0D0D0D] border border-[rgba(217,164,65,0.35)] rounded-md p-5 md:p-6 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)]">
      <div className="text-[11px] tracking-[0.24em] uppercase text-[#D9A441] font-semibold">Cookies &amp; Analytics</div>
      <p className="mt-3 text-[14px] text-[#B5B5B5] leading-relaxed">
        We use minimal cookies to understand how visitors use this site and to improve the program experience. Read our <Link to="/privacy" className="text-white underline underline-offset-2 hover:text-[#D9A441]">Privacy Policy</Link>.
      </p>
      <div className="mt-5 flex gap-3">
        <button onClick={() => decide("accepted")} data-testid="cookie-accept" className="bcu-btn-primary text-[13px] tracking-[0.10em] uppercase px-4 py-2.5">Accept</button>
        <button onClick={() => decide("declined")} data-testid="cookie-decline" className="bcu-btn-secondary text-[13px] tracking-[0.10em] uppercase px-4 py-2.5">Decline</button>
      </div>
    </div>
  );
}
